import React from 'react'
import classNames from 'classnames'
import ContentAdd from 'material-ui/svg-icons/content/add-circle-outline'
import ContentRemove from 'material-ui/svg-icons/content/remove-circle-outline'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import mission from '../../constants/mission'

const Mission = ({ clickHandler, missionToggled }) => {
  const missionExpandedText = mission.map((sentence, index) => {
    return (
            <div key={index}>
              <p>{sentence}</p>
              <br/>
            </div>
            )
  })

  const missionTextClassNames = classNames({
    'collapsed': !missionToggled,
    'expanded': missionToggled,
    'mission-text': true,
  })
  
  return (
    <div className={'mission-statement'}>
      <h1 className="title">MISSION STATEMENT</h1>
      <p className="mission-header-text">Mind Makers’ mission is to equip and inspire unconventional communities through STEM education, outreach and service. Our vision is of a diverse, technology proficient community that values knowledge sharing, redefines possibility and inspires a new wave of engineering enthusiasts.</p>
      <div className={missionTextClassNames}>
          { missionExpandedText }
      </div>
      <FloatingActionButton
        className={'floating-button'}
        mini={true}
        onMouseDown={clickHandler.bind(this, null)}>
        {missionToggled ? <ContentRemove style={{ height: "40px", width: "40px"}}/> : <ContentAdd style={{ height: "40px", width: "40px"}}/> }
      </FloatingActionButton>
    </div>
  )
}

export default Mission



// WEBPACK FOOTER //
// ./src/components/About/Mission.js